import React from "react";
import { HiDotsHorizontal } from "react-icons/hi";
import { CommunityProps } from "../../types";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { DELETE_COMMUNITY } from "../../apollo/operations";
import { useNavigate } from "react-router-dom";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { CiUser } from "react-icons/ci";
import { Shimmer, SkeletonElement } from "..";

type UserMenuProps = {
  community: CommunityProps | undefined;
  refetch?: () => void;
  loading?: boolean;
};

const UserMenu: React.FC<UserMenuProps> = ({ community, refetch, loading }) => {
  const [openOption, setOpenOption] = React.useState(false);
  const user = useSelector((state: any) => state.user.userDetails);
  const [deleteCommunity] = useMutation(DELETE_COMMUNITY, {
    onCompleted(data) {
      if (refetch) {
        refetch();
      }
    },
    notifyOnNetworkStatusChange: true,
    onError: (err) => {
      console.log(err);
      const errorMsg = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMsg);
    },
  });

  const navigate = useNavigate();
  const handleDelete = () => {
    setOpenOption(false);
    if (user.id === community?.creator.id) {
      deleteCommunity({
        variables: {
          where: {
            id: community?.id,
          },
        },
      }).then(() => {
        if (refetch) {
          refetch();
        }
        navigate("/ecobook/my-communities");
      });
    }
  };
  function formatISODate(isoDateString: string) {
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
      // hour: 'numeric',
      // minute: 'numeric',
      // second: 'numeric',
      // timeZone: 'GMT',
      // timeZoneName: 'short',
    };

    const date = new Date(isoDateString);
    return date.toLocaleString("en-US", options);
  }

  const isoString = community?.createdAt;
  const formattedDate = formatISODate(isoString!);

  let _pImage: string | null = community?.creator?.ecobookProfile?.profileImage ?? "";


  return (
    <div className="lg:shadow-sm px-4 w-full rounded-sm bg-white h-[62px] flex justify-between items-center">
      <div className="flex gap-3">
        <div className="w-9 h-9 rounded-full">
          {loading && (
            <div className="w-9 flex items-center justify-center">
              <div className="w-9 h-9 relative overflow-hidden">
                <SkeletonElement type="imageUser" />
                <Shimmer />
              </div>
            </div>
          )}
          {!loading &&
            (_pImage ? (
              community?.id && (
                <img
                  alt="user img"
                  src={ipfsGatewayImage(_pImage)}
                  className="w-9 h-9 rounded-full"
                />
              )
            ) : (
              <div className="w-10 h-10 bg-slate-100 flex items-center justify-center rounded-full">
                <CiUser size={20} />
              </div>
            ))}
        </div>
        <div className="font-SegoeUI">
          <h4 className="text-transBlack font-semibold text-sm">
            {community?.creator
              ? `${community.creator.firstName} ${community.creator.lastName}`
              : community?.members &&
                `${community.members[0].firstName} ${community.members[0].lastName}`}
          </h4>
          <h5 className="font-normal text-xs text-TransGrey">{`created on ${formattedDate}`}</h5>
        </div>
      </div>
      <div className="relative cursor-pointer">
        <HiDotsHorizontal
          size={20}
          onClick={() => setOpenOption(!openOption)}
        />
      </div>
      {openOption && user?.id === community?.creator.id && (
        <ul className="bg-white z-10 py-4 px-2 text-center rounded-sm rounded-tr-none shadow-[1px_-1px_10px_5px_rgba(0,0,0,0.1)] transform translate-y-1 ease-linear font-Jakarta text-xs font-semibold text-lightBlack duration-200 absolute right-7 top-[100px]">
          <div className="absolute border-l-[20px] border-l-transparent border-b-white border-b-[25px] border-solid top-[-18px] right-0">
            {" "}
          </div>
          <li
            className="text-center cursor-pointer hover:bg-gray-100 py-1 hover:rounded"
            onClick={handleDelete}
          >
            Delete community
          </li>
          <li
            className="w-[95%] cursor-pointer hover:bg-gray-100 py-1 hover:rounded my-1"
            // onClick={handleEdit}
          >
            Edit
          </li>
        </ul>
      )}
    </div>
  );
};

export default UserMenu;
